import { CONTENT_TYPES, roleStyle } from "../lib/api";
import { useRoles } from "../context/RolesContext";

const STATUS = {
  queued: ["In Queue", "bg-sky-500/10 text-sky-300 border-sky-500/30"],
  in_progress: ["In Progress", "bg-orange-500/10 text-orange-300 border-orange-500/30"],
  completed: ["Completed", "bg-emerald-500/10 text-emerald-300 border-emerald-500/30"],
  sent_back: ["Sent Back", "bg-rose-500/10 text-rose-300 border-rose-500/30"],
  pending: ["Pending", "bg-amber-500/10 text-amber-300 border-amber-500/30"],
  approved: ["Approved", "bg-emerald-500/10 text-emerald-300 border-emerald-500/30"],
  rejected: ["Rejected", "bg-rose-500/10 text-rose-300 border-rose-500/30"],
  cancelled: ["Cancelled", "bg-slate-500/10 text-slate-300 border-slate-500/30"],
  superseded: ["Replaced", "bg-slate-500/10 text-slate-300 border-slate-500/30"],
  expired: ["Expired", "bg-slate-500/10 text-slate-400 border-slate-500/30"],
};

const base = "inline-flex items-center gap-1 rounded-md border px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider whitespace-nowrap";

export const StatusBadge = ({ status, testId }) => {
  const [label, cls] = STATUS[status] || [status, "border-[#282E3D] text-slate-400"];
  return <span data-testid={testId} className={`${base} ${cls}`}>{label}</span>;
};

export const RoleBadge = ({ role }) => {
  const r = useRoles().roleMap[role];
  return <span className={base} style={roleStyle(r?.color)}>{r?.label || role.replace(/_/g, " ")}</span>;
};

export const TypeBadge = ({ type }) => {
  const t = CONTENT_TYPES[type] || { label: type, color: "#94A3B8" };
  return (
    <span className={`${base} border-[#282E3D] text-slate-200`}>
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: t.color }} />
      {t.label}
    </span>
  );
};

export const ClassLinkedBadge = () => (
  <span className={`${base} bg-purple-500/10 text-purple-300 border-purple-500/30`}>Class-linked</span>
);
